export default {
  isSubmitting: false,
  activeStore: undefined, // pode ser String ou Array
  hideHeader: false,
  isSearching: false,
};
